export const hasTargetThatCanBeDisabled = ( event: UIEvent ): event is HasTargetThatCanBeDisabled => {
    return typeof event === 'object'
        && event != null
        && typeof event.target === 'object'
        && event.target != null
        && 'disabled' in event.target
        && typeof ( event.target as TargetCanBeDisabled ).disabled === 'boolean';
};

export const hasFiles = ( event: unknown ): event is { files: File[] } => {
    return typeof event === 'object'
        && event != null
        && 'files' in event
        && typeof ( event as { files: unknown } ).files === 'object'
        && Array.isArray( ( event as { files: unknown } ).files )
        && ( event as { files: unknown[] } ).files.every( ( f: unknown ) => f instanceof File );
};

export const hasQuery = ( event: unknown ): event is HasQuery => {
    return typeof event === 'object'
        && event != null
        && 'query' in event
        && typeof ( event as HasQuery ).query === 'string';
};

interface HasTargetThatCanBeDisabled extends UIEvent {
    target: TargetCanBeDisabled;
}

interface TargetCanBeDisabled extends EventTarget {
    disabled: boolean;
}

interface HasQuery {
    query: string;
}
